import { requestData } from '@/api/request';
import type {
  ChangePasswordPayload,
  AuthTokens,
  AuthUser,
  LoginCredentials,
  MessageResponse,
  PasswordResetConfirmPayload,
  PasswordResetRequestPayload,
} from '@/api/types';

export async function loginRequest(credentials: LoginCredentials) {
  return requestData<AuthTokens, LoginCredentials>({
    url: 'auth/login/',
    method: 'post',
    data: credentials,
    authMode: 'public',
  });
}

export async function getCurrentUser() {
  return requestData<AuthUser>({
    url: 'auth/me/',
  });
}

export async function logoutRequest() {
  await requestData<{ message: string }>({
    url: 'auth/logout/',
    method: 'post',
  });
}

export async function changePasswordRequest(payload: ChangePasswordPayload) {
  return requestData<MessageResponse, ChangePasswordPayload>({
    url: 'auth/change-password/',
    method: 'post',
    data: payload,
  });
}

export async function passwordResetRequest(payload: PasswordResetRequestPayload) {
  return requestData<MessageResponse, PasswordResetRequestPayload>({
    url: 'auth/password-reset/request/',
    method: 'post',
    data: payload,
    authMode: 'public',
  });
}

export async function passwordResetConfirm(payload: PasswordResetConfirmPayload) {
  return requestData<MessageResponse, PasswordResetConfirmPayload>({
    url: 'auth/password-reset/confirm/',
    method: 'post',
    data: payload,
    authMode: 'public',
  });
}